import axiosInstance from "../../apiAxios/axiosInstance";

export const WhereHouseList = async (payload) => {
  const response = await axiosInstance.post("/vendor/warehouses-list", payload);
  return response.data;
};
export const ActiveWhereHouseList = async (payload) => {
  const response = await axiosInstance.post("/vendor/active-warehouses-list", payload);
  return response.data;
};
export const ActiveSupplierList = async(payload) => {
   const resposne=await axiosInstance.post("/vendor/active-supplier-list",payload);
   return resposne.data
};
export const AddWhereHouse= async (payload) => {
  const response = await axiosInstance.post("/vendor/warehouses-store", payload);
  return response.data;
};

export const ViewWhereHouse = async (payload) => {
  const response = await axiosInstance.post("/vendor/warehouses-show", payload);
  return response.data;
};

export const UpdateWhereHouse = async (payload) => {
  const response = await axiosInstance.post("/vendor/warehouses-update", payload);
  return response.data;
};

export const DeleteWhereHouse = async (payload) => {
  const response = await axiosInstance.post("/vendor/warehouses-delete", payload);
  return response.data;
};

export const WhereHouseChangeStatus = async (payload) => {
  const response = await axiosInstance.post(
    "/vendor/warehouses-status-update",
    payload
  );
  return response.data;
};